var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpecialIco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70.932,
    height: 70.933,
    viewBox: "0 0 70.932 70.933",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Mask",
    width: 70.933,
    height: 70.933,
    rx: 19,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M0,20.536A17.946,17.946,0,0,1,15.4,2.785V13.3a7.687,7.687,0,1,0,9.8,9.8H35.721A17.952,17.952,0,0,1,0,20.536Zm38.5,0H23.1A5.137,5.137,0,0,0,17.969,15.4V0A20.559,20.559,0,0,1,38.505,20.535h0ZM20.536,13.275a7.8,7.8,0,0,1,4.694,4.694H35.756a18.012,18.012,0,0,0-15.22-15.22Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_806",
    "data-name": "Group 806",
    transform: "translate(-162.266 -2232.494)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color_Primary",
    "data-name": "Color/Primary",
    transform: "translate(162.266 2232.494)",
    opacity: 0.201
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Mask-2",
    "data-name": "Mask",
    width: 70.933,
    height: 70.933,
    rx: 19,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "pie-chart",
    transform: "translate(178.479 2248.707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape-2",
    "data-name": "Combined Shape",
    d: "M0,20.536A17.946,17.946,0,0,1,15.4,2.785V13.3a7.687,7.687,0,1,0,9.8,9.8H35.721A17.952,17.952,0,0,1,0,20.536Zm38.5,0H23.1A5.137,5.137,0,0,0,17.969,15.4V0A20.559,20.559,0,0,1,38.505,20.535h0ZM20.536,13.275a7.8,7.8,0,0,1,4.694,4.694H35.756a18.012,18.012,0,0,0-15.22-15.22Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6",
    "data-name": "Mask Group 6",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_color",
    "data-name": "\\uD83C\\uDFA8 color",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 38.506,
    height: 38.506,
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialIco);
export default __webpack_public_path__ + "static/media/specialIco.f1ee6e64b10e6b0f50a4ba3fed42f4ee.svg";
export { ForwardRef as ReactComponent };